/** @jsx jsx */

import { Colors, Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

const Styles = {
  root: css`
    border: 1px solid ${Colors.GrayWarm3};
    border-radius: 10px;
    height: 91px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
  `,
};

type Props = {
  issueType?: string;
};

const getNoIssuesMessage = (issueType?: string) => {
  switch (issueType) {
    case 'Bug':
      return 'No Open Bugs';
    case 'Feature Request':
      return 'No Open Feature Requests';
    default:
      return 'No Open Bugs or Feature Requests';
  }
};

const NoIssues = ({ issueType }: Props) => (
  <section css={Styles.root}>
    <Text type="Body1">{getNoIssuesMessage(issueType)}</Text>
  </section>
);

export default NoIssues;
